<template>
  <el-card ref="card">
    <el-table :data="goods">
      <el-table-column
        prop="customsDeclareGoodsId"
        label="商品备案id"
        width="180"
      >
      </el-table-column>
      <el-table-column prop="skuName" label="商品备案名称"> </el-table-column>
      <el-table-column prop="itemNo" label="商品料号" width="250">
      </el-table-column>
      <el-table-column prop="purchaseQuantity" label="采购数量" width="150">
      </el-table-column>
      <el-table-column prop="declareQuantity" label="申报数量" width="150">
      </el-table-column>
      <el-table-column prop="unDeclareQuantity" label="未申报数量" width="150">
      </el-table-column>
      <el-table-column prop="unitPrice" label="单价" width="150">
      </el-table-column>
      <el-table-column prop="totalPrice" label="总价" width="150">
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import purchaseApi from "@/api/purchase";

export default {
  data() {
    return {
      goods: [],
    };
  },
  created() {
    const purchaseId = this.$route.params.purchaseId;
    purchaseApi.load({ purchaseId }).then((res) => {
      this.goods = res.items;
    });
  },
  watch: {
    $route(to, from) {
      if (to.name === "purchaseOrderDetail") {
        const purchaseId = this.$route.params.purchaseId;
        purchaseApi.load({ purchaseId }).then((res) => {
          this.goods = res.items;
        });
      }
    },
  },
};
</script>
